exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".user-box[data-v-442f7146]{width:350px}.user-box .count[data-v-442f7146]{text-align:right}.user-content[data-v-442f7146]{width:100%;height:300px;border:1px solid #8e8e8e;margin-top:5px;border-radius:4px;overflow-y:scroll}.el-tag[data-v-442f7146]{margin:5px;float:left}.el-select[data-v-442f7146]{width:560px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-442f7146&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/OperationManage/UserAdminister/PersonalizedPart/Components/SelectStudent.vue
// module id = 510
// module chunks = 0